import { createTheme } from "@mui/material/styles"
import "@fontsource-variable/roboto-slab"

const display = "Roboto Slab Variable, serif"
const body = '"Inter Variable", Inter, system-ui, -apple-system, "Segoe UI", Roboto, sans-serif'

// The brand palette, named once so a rebrand is one edit rather than six.
const NAVY = "#0c2d5f"
const NAVY_DARK = "#071d3e"
const GOLD = "#e1b153"
const GOLD_DARK = "#ca952d"
// The cream page and chip tint. A background wash, not a shade of the gold --
// which is exactly the distinction the `light` slots below turn on.
const CREAM = "#fef9f0"
const RED = "#CC2936"

// Gold is the warning color in this theme.
// Rebrand `secondary` and `warning` together if the brand gold ever changes.
//
// The two differ in one slot, deliberately. MUI derives a standard Alert's
// background as `lighten(palette[severity].light, 0.9)`, so `.light` has to be a
// real shade of the color. `secondary.light` is the cream wash, which is right
// for the handful of places that paint with it directly, but lightening
// near-white by 90% gives white -- so a warning Alert carrying that value had no
// background at all and its text fell back to grey. `warning.light` therefore
// holds the gold itself, which yields a legible cream Alert with dark gold text,
// at the same weight as the pink `error` already produces.
export const defaultTheme = createTheme({
  palette: {
    primary: { main: NAVY, dark: NAVY_DARK, contrastText: "#ffffff" },
    secondary: { main: GOLD, dark: GOLD_DARK, light: CREAM, contrastText: NAVY },
    warning: { main: GOLD, dark: GOLD_DARK, light: GOLD, contrastText: NAVY },
    error: { main: RED },
    text: { primary: "#161110", secondary: "#555" },
    divider: "#e0e0e0"
  },
  typography: {
    fontFamily: body,
    h3: { fontSize: 23, fontWeight: 400, fontFamily: display },
    h4: { fontSize: 20, fontWeight: 600 },
    h5: { fontSize: 19, fontWeight: 400, fontFamily: display },
    h6: { fontSize: 17, fontWeight: 600 },
    h7: { fontSize: 16, fontWeight: 500 },
    subtitle1: { fontSize: 15, fontWeight: 600, color: "gray" },
    subtitle2: { fontSize: 13, fontWeight: 200, color: "gray" },
    button: { padding: "15px", color: "gray", cursor: "pointer" },
    buttonSecondary: {
      padding: "5px 8px",
      color: NAVY,
      backgroundColor: GOLD,
      borderRadius: "3px",
      cursor: "pointer",
      fontFamily: display
    }
  }
})
